import { NgModule } from '@angular/core';

import { ZonarUIBrandModule } from './zonar-ui-brand/zonar-ui-brand.module';
import { ZonarUiFaviconModule } from './zonar-ui-favicon/zonar-ui-favicon.module';

import { TranslationService } from './services/translation.service';

@NgModule({
  declarations: [],
  imports: [ZonarUIBrandModule, ZonarUiFaviconModule],
  exports: [ZonarUIBrandModule, ZonarUiFaviconModule],
  providers: [TranslationService]
})
export class ZonarUICoreModule {}
